import { isEqual } from 'lodash';
import { AssigneeValue } from '../fields';
import { AssigneeFieldFilter } from '../filters/assignee';
import { SelectFilterOperationType } from '../filters/select';
import type { FilterFunction } from './types';

const value = (record: Record<string, unknown>): AssigneeValue[] =>
  record.assignee ?? ([] as any);

export const assignee = (filter: AssigneeFieldFilter): FilterFunction => {
  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return (record) => (value(record) ?? []).length === 0;
    case SelectFilterOperationType.IsNotEmpty:
      return (record) => (value(record) ?? []).length !== 0;
    case SelectFilterOperationType.Is:
      return (record) => {
        const fieldValue = new Set(
          (value(record) ?? []).map(AssigneeValue.toString),
        );
        const filterValue = new Set(filter.value!.map(AssigneeValue.toString));

        return isEqual(fieldValue, filterValue);
      };
    case SelectFilterOperationType.IsNot:
      return (record) => {
        const fieldValue = new Set(
          (value(record) ?? []).map(AssigneeValue.toString),
        );
        const filterValue = new Set(filter.value!.map(AssigneeValue.toString));

        return !isEqual(fieldValue, filterValue);
      };
    case SelectFilterOperationType.IsOneOf:
      return (record) => {
        const fieldValue = (value(record) ?? []).map(AssigneeValue.toString);
        const filterValue = filter.value!.map(AssigneeValue.toString);

        return filterValue.some((v) => fieldValue.includes(v));
      };
    case SelectFilterOperationType.IsNoneOf:
      return (record) => {
        const fieldValue = (value(record) ?? []).map(AssigneeValue.toString);
        const filterValue = filter.value!.map(AssigneeValue.toString);

        return filterValue.every((v) => !fieldValue.includes(v));
      };
    default:
      return () => true;
  }
};
